import PropTypes from 'prop-types';
import classnames from 'classnames';
import React from 'react';
import Link from 'react-router/lib/Link';

const LocateDuplicatesButton = ({
  link,
  linkClass,
  children,
  isVisible,
}) => (
  <Link to={link} display-if={isVisible} className={classnames('c-btn c-btn--medium c-btn--ghost', linkClass)}>
    {children || 'Locate Duplicates'}
  </Link>
);

LocateDuplicatesButton.propTypes = {
  link: PropTypes.string.isRequired,
  linkClass: PropTypes.string,
  children: PropTypes.node,
  isVisible: PropTypes.bool,
};

LocateDuplicatesButton.defaultProps = {
  linkClass: '',
  children: null,
  isVisible: false,
};

export default LocateDuplicatesButton;
